import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { handleGetRequest } from "../../services/GetTemplate";
import styles from "./customerDialogs.module.scss";

const AddCustomerDialog = ({ onHideTyreBrandDialog, onsuccess }) => {
    const [role, setRole] = useState();
    const dispatch = useDispatch();
    const [selectedDelivery, setSelectedDelivery] = useState(null);
    const [DeliveryInfos, setDeliveryInfos] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const getData = async () => {
        const res = await handleGetRequest(`/getAllDeliveryInfo`);
        setDeliveryInfos(res?.data);
    };

    useEffect(() => {
        getData();
    }, []);

    const formik = useFormik({
        initialValues: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
            TRN: "",
            mailingAddress: "",
            deliveryAddress: "",
            businessName: "",
            TCC: "",
            businessType: "",
            dateJoined: "",
            role: "",
            password: "",
            date: moment().format("DD-MM-YYYY"),
            verified: true,
            isPartner: false,
            deliveryInfo: "",
        },

        onSubmit: async (data) => {
            if (isSubmitting) return;
            data.role = role;
            data.dateJoined = Date.now();
            if (!data?.firstName) {
                toast.error("Please enter first name");
            } else if (!data?.lastName) {
                toast.error("Please enter last name");
            } else if (!data?.email) {
                toast.error("Please enter email");
            } else if (!data?.password) {
                toast.error("Please enter password");
            } else if (!data?.phone) {
                toast.error("Please enter phone");
            } else if (!data?.role) {
                toast.error("Please select role");
            } else {
                if (data.role === "partner") {
                    data.role = "courier";
                    data.isPartner = true;
                }
                data.deliveryInfo = selectedDelivery;
                setIsSubmitting(true);
                try {
                    const result = await dispatch(handlePostRequest(data, "/singup", true, true));
                    if (result !== "error") {
                        onsuccess();
                    }
                } finally {
                    setIsSubmitting(false);
                }
            }
        },
    });

    const showBusinessFields = role === "client" || role === "courier" || role === "corporate" || role === "reseller";

    return (
        <form onSubmit={formik.handleSubmit} className={styles.dialogForm}>
            <div className={styles.fieldsGrid}>
                <div className={styles.field}>
                    <label htmlFor="firstName">First Name</label>
                    <InputText id="firstName" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="lastName">Last Name</label>
                    <InputText id="lastName" name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="email">Email Address</label>
                    <InputText id="email" name="email" value={formik.values.email} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="password">Password</label>
                    <InputText id="password" name="password" value={formik.values.password} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="phone">Phone Number</label>
                    <InputText id="phone" name="phone" value={formik.values.phone} onChange={formik.handleChange} />
                </div>
                <div className={styles.field}>
                    <label htmlFor="role">User Type</label>
                    <select id="role" value={role} onChange={(e) => setRole(e.target.value)}>
                        <option disabled defaultValue="">
                            Select Role
                        </option>
                        <option value="client">Client</option>
                        <option value="courier">Courier</option>
                        <option value="partner">Partner</option>
                        <option value="corporate">Corporate</option>
                        <option value="reseller">Reseller</option>
                    </select>
                </div>
                <div className={`${styles.field} ${styles.fullWidth}`}>
                    <label htmlFor="deliveryInfo">Delivery Info</label>
                    <select id="deliveryInfo" value={selectedDelivery} onChange={(e) => setSelectedDelivery(e.target.value)}>
                        <option disabled defaultValue="">
                            Please select delivery information
                        </option>
                        {DeliveryInfos?.map((item) => (
                            <option key={item.name} value={item.name}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>

                {showBusinessFields && (
                    <>
                        <div className={styles.field}>
                            <label htmlFor="mailingAddress">Mailing Address</label>
                            <InputText id="mailingAddress" name="mailingAddress" value={formik.values.mailingAddress} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="TRN">TRN</label>
                            <InputText id="TRN" name="TRN" value={formik.values.TRN} onChange={formik.handleChange} />
                        </div>
                        <div className={`${styles.field} ${styles.fullWidth}`}>
                            <label htmlFor="deliveryAddress">Delivery Address</label>
                            <InputText id="deliveryAddress" name="deliveryAddress" value={formik.values.deliveryAddress} onChange={formik.handleChange} />
                        </div>
                    </>
                )}

                {role === "courier" && (
                    <>
                        <div className={styles.field}>
                            <label htmlFor="businessName">Business Name</label>
                            <InputText id="businessName" name="businessName" value={formik.values.businessName} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="businessType">Business Type</label>
                            <InputText id="businessType" name="businessType" value={formik.values.businessType} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="TCC">TCC</label>
                            <InputText id="TCC" name="TCC" value={formik.values.TCC} onChange={formik.handleChange} />
                        </div>
                    </>
                )}
            </div>

            <div className={styles.actions}>
                <Button label={isSubmitting ? "Creating..." : "Create"} className={styles.submitButton} disabled={isSubmitting} icon={isSubmitting ? "pi pi-spin pi-spinner" : ""} />
            </div>
        </form>
    );
};

export default AddCustomerDialog;
